import {
  applyMenuPosition,
  calculateHorizontalPosition,
  calculateVerticalPosition,
} from "helpers/dropdown_positioning"
import MenuController from "./menu_controller"

export default class DropdownMenuController extends MenuController {
  static targets = ["menu", "trigger"]
  static values = {
    open: { type: Boolean, default: false },
    alignment: { type: String },
  }

  connect() {
    super.connect()
    this.boundUpdatePosition = this.#updatePosition.bind(this)
    window.addEventListener("resize", this.boundUpdatePosition)
  }

  #updatePosition() {
    if (!this.openValue) return

    const triggerRect = this.triggerTarget.getBoundingClientRect()

    this.menuTarget.style.position = "fixed"
    if (this.menuTarget.dataset.dropdownMenuInheritTriggerWidth === "true") {
      this._setMenuWidth(triggerRect)
    }

    const menuRect = this.menuTarget.getBoundingClientRect()

    const { top, left } = this.#calculateMenuCoordinates(triggerRect, menuRect)
    applyMenuPosition(this.menuTarget, top, left)

    requestAnimationFrame(this.boundUpdatePosition)
  }

  #calculateMenuCoordinates(triggerRect, menuRect) {
    const top = calculateVerticalPosition(triggerRect, menuRect)

    const initialLeftValue =
      this.alignmentValue === "right"
        ? triggerRect.right - menuRect.width
        : triggerRect.left
    const left = calculateHorizontalPosition(initialLeftValue, menuRect)

    return { top, left }
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    this.openValue = !this.openValue

    if (this.openValue) {
      this.#updatePosition()
    } else {
      this.resetToOriginalSelectedItem()
    }
  }

  hide(event) {
    if (this.element.contains(event.target) === false) {
      this.menuTarget.classList.add("hidden")
      this.openValue = false
      this.resetToOriginalSelectedItem()
      this.dispatch("hidden")
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.boundUpdatePosition)
  }
}
